import { CmsDetailAdmin } from '../../../components/Cms';

export function Cms() {
  return <CmsDetailAdmin />;
}
